import gatsby from './gatsby.png';
import gla from './Image-01.png';
import famlaw from './Image-01a.png';
import contract from './Image-02.png';
import inhreritance from './Image-02a.png';
import laborlaw from './Image-03.png';
import livelaw from './Image-04.png';
import criminal from './Image-05.png';
import adres from './adres_icon.png';
import mail from './mail_icon.png';
import phone from './phone_icon.png';

export {
    gatsby,
    gla,
    famlaw,
    contract,
    inhreritance,
    laborlaw,
    livelaw,
    criminal,
    adres,
    mail,
    phone
};